import { render, staticRenderFns } from "./LandingPageNews.vue?vue&type=template&id=6c4420cf"
import script from "./LandingPageNews.vue?vue&type=script&lang=js"
export * from "./LandingPageNews.vue?vue&type=script&lang=js"
import style0 from "./LandingPageNews.vue?vue&type=style&index=0&id=6c4420cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports